export default __webpack_public_path__ + "static/media/logo.bca5fbba.png";